import { render } from "./SdsyHeader.vue?vue&type=template&id=78d216c3"
import script from "./SdsyHeader.vue?vue&type=script&lang=js"
export * from "./SdsyHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gaole\\Documents\\work\\dc\\www.tzspace.cn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__